import { FC } from 'react';
import styled from 'styled-components';

import { PrivateDocumentCategory } from '@/shared/lib/sj-orm';

import { useI18nValues } from '../../hooks/useI18nValues';
import { PrivateDocumentCategoryIcon } from '../PrivateDocumentCategoryIcon';

type PrivateDocumentCategoryItemProps = {
  category: PrivateDocumentCategory;
  icon?: boolean;
  name?: boolean;
};

export const PrivateDocumentCategoryItem: FC<PrivateDocumentCategoryItemProps> = ({
  category,
  name,
  icon,
}) => {
  const values = useI18nValues();

  const showIcon = (!icon && !name) || icon;
  const showName = (!icon && !name) || name;

  return (
    <Container>
      {showIcon && <PrivateDocumentCategoryIcon category={category} />}
      {showName && <span>{values.category(category)}</span>}
    </Container>
  );
};

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;
